export default __webpack_public_path__ + "static/media/eggsIcon_img.5f5dc04f.png";